import React, { useState } from "react";

const ImageUpload = ({ question, accept, value, onChange }) => {
  const [preview, setPreview] = useState(value?.preview || null);
  const [fileName, setFileName] = useState(value?.name || "");
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setError("");

    if (!file) {
      return;
    }

    // Validate file type
    if (!file.type.startsWith("image/")) {
      setError("Please upload only image files");
      return;
    }

    // Validate file size (max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      setError("File size should not exceed 5MB");
      return;
    }

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
      setFileName(file.name);
      onChange({
        file: file,
        preview: reader.result,
        name: file.name
      });
    };
    reader.readAsDataURL(file);
  };

  const handleRemove = () => {
    setPreview(null);
    setFileName("");
    setError("");
    onChange(null);
  };

  return (
    <div className="image-upload-question">
      <h4 className="question-text mb-4">{question}</h4>

      {!preview ? (
        <div className="upload-area border rounded p-4 text-center">
          <input
            type="file"
            id="image-upload"
            className="d-none"
            accept={accept}
            onChange={handleFileChange}
          />
          <label htmlFor="image-upload" className="btn btn-outline-primary btn-lg">
            <i className="bi bi-cloud-upload me-2"></i>
            Choose Image
          </label>
          <p className="mt-3 text-muted">
            Accepted formats: JPG, PNG, GIF (Max size: 5MB)
          </p>
        </div>
      ) : (
        <div className="image-preview-area">
          <div className="preview-container border rounded p-3">
            <img
              src={preview}
              alt="Preview"
              className="img-fluid rounded mb-3"
              style={{ maxHeight: "300px", objectFit: "contain" }}
            />
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-muted">{fileName}</span>
              <button
                className="btn btn-danger btn-sm"
                onClick={handleRemove}
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      )}

      {error && (
        <div className="alert alert-danger mt-3" role="alert">
          {error}
        </div>
      )}
    </div>
  );
};

export default ImageUpload;
